import React, { useState, useEffect } from "react";
import {
  FilterIconRent,
} from "../../AssetComponents/Images";
import { PurpleButton } from "../../Components/Buttons/PurpleButton";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-responsive-modal";
import "react-range-slider-input/dist/style.css";
import {
  setPriceRange,
  setAmenities,
  setPropertyType,
  setInstantBook,
  setAllowPets,
} from "../../ReduxSlices/SearchSlice";
import { BlackButton } from "../../Components/Buttons/BlackButton";
import { applyFilters, getDefaultFilters, getFilteredAndSortedProperties } from "../functions/FilterApi";
import { amenityCategories } from "./FilterConstants";
import { PriceRangeSection } from "./FilterPriceRangeSection";
import { FilterButton } from "./FilterButton";
import { BedroomFilter } from "./BedroomFilter";
import { BedFilter } from "./BedFilter";
import { BathroomFilter } from "./BathroomFilter";
import { PropertyTypeFilter } from "./PropertyTypeFilter";
import { BookingOptions } from "./BookingOptions";
import FilterAmenities from "./FilterComponents/FilterAmenities ";
import { FilterHeader } from "./FilterHeader";
import { FilterModal } from "./FilterModal";

export const Filter = ({ properties, onFilterChange, currentSortType }) => {
  // Redux state
  const reservation_period = useSelector((state) => state.reservation.period);
  const who = useSelector((state) => state.reservation.who);
  const guests = useSelector((state) => state.reservation.guests);
  const amenities = useSelector((state) => state.search.amenities);
  const propertyType = useSelector((state) => state.search.propertyType);
  const instantBook = useSelector((state) => state.search.instantBook);
  const allowPets = useSelector((state) => state.search.allowPets);
  const range = useSelector((state) => state.search.priceRange);
  
  // Local state
  const [openFilter, setOpenFilter] = useState(false);
  const [metaDetails, setMetaDetails] = useState({ amenities: {} });
  const [loading, setLoading] = useState(false);
  
  const dispatch = useDispatch();
   const applyAllFilters = async () => {
    try {
      setLoading(true);
      
      const filterParams = {
        range,
        amenities,
        propertyType,
        instantBook,
        allowPets,
        guests,
        metaDetails,
        reservation_period,
        properties // Pass properties for fallback
      };
      
      console.log('Filter component - applying unified filters:', filterParams);
      console.log('Filter component - current sort type:', currentSortType);
      
      // Use the new unified function that handles both filtering and sorting
      const result = await getFilteredAndSortedProperties(
        filterParams,
        currentSortType !== 'default' ? currentSortType : 'newest',
        (results) => {
          console.log('Unified filter & sort callback received results:', results?.length || 0);
          onFilterChange(results);
        },
        setLoading,
        setOpenFilter
      );
      
      console.log('Unified filter & sort completed successfully:', result);
      
      // Close the modal after successful filtering
      setOpenFilter(false);
      
    } catch (error) {
      console.error("Error applying unified filters:", error);
      setLoading(false);
      
      // If unified filtering fails, fallback to local filtering
      console.log('Falling back to local filtering...');
      try {
        const filteredResults = await applyFilters(
          properties,
          {
            range,
            amenities,
            propertyType,
            instantBook,
            allowPets,
            guests,
            metaDetails,
            reservation_period
          },
          onFilterChange,
          setLoading,
          setOpenFilter
        );
        
        // Close the modal after successful fallback filtering
        setOpenFilter(false);
        
      } catch (fallbackError) {
        console.error("Fallback filtering also failed:", fallbackError);
        alert("There was an error applying filters. Please try again.");
        onFilterChange(properties);
        
        // Close the modal even if fallback fails
        setOpenFilter(false);
      }
    } finally {
      // Always reset loading state
      setLoading(false);
    }
  };

  // Clear all filters
  const handleClear = () => {
    const defaultFilters = getDefaultFilters();
    
    // Reset Redux state
    dispatch(setPriceRange(defaultFilters.priceRange));
    dispatch(setAmenities(defaultFilters.amenities));
    dispatch(setPropertyType(defaultFilters.propertyType));
    dispatch(setInstantBook(defaultFilters.instantBook));
    dispatch(setAllowPets(defaultFilters.allowPets));
    
    // Reset local state
    setMetaDetails({ amenities: {} });
    
    // Reset to all properties
    onFilterChange(properties);
  };

  // Price range is now handled by the PriceRangeSection component

  return (
    <div>
      <FilterButton onClick={() => setOpenFilter(true)} />
      <FilterModal open={openFilter} onClose={() => setOpenFilter(false)}>
        <div className="w-full filter-modal-container">
          <FilterHeader />
          <div className="h-[50vh] sm:h-[60vh] md:h-[50vh] overflow-auto scrollbarwidth px-[10px] sm:px-[15px] md:px-[10px] filter-modal-mobile filter-content-mobile">
                          {/* Price Range Section */}
              <div className="w-full filter-section-mobile">
                <PriceRangeSection 
                  range={range} 
                  onRangeChange={(value) => dispatch(setPriceRange(value))}
                  properties={properties}
                />
              </div>
            <div className="w-full h-[2px] bg-[#eeeeee] my-[12px]" />
            
            {/* Rooms and Beds Section */}
            <div className="space-y-[12px] filter-section-mobile">
              <div className="text-[16px] sm:text-[18px] font-semibold">
                Rooms and beds
              </div>
              <BedroomFilter amenities={amenities} dispatch={dispatch} />
              <BedFilter amenities={amenities} dispatch={dispatch} />
              <BathroomFilter amenities={amenities} dispatch={dispatch} />                    
            </div>
            <div className="w-full h-[2px] bg-[#eeeeee] my-[12px]" />
            
            {/* Property Type Section */}
            <div className="filter-section-mobile">
              <PropertyTypeFilter propertyType={propertyType} dispatch={dispatch} />
            </div>
            <div className="w-full h-[2px] bg-[#eeeeee] my-[12px]" />
            
            {/* Booking Options Section */}
            <div className="filter-section-mobile">
              <BookingOptions instantBook={instantBook} allowPets={allowPets} dispatch={dispatch} />
            </div>
            <div className="w-full h-[2px] bg-[#eeeeee] my-[12px]" />

            {/* Amenities Section */}
            <div className="w-full space-y-[10px] filter-section-mobile">
              <FilterAmenities 
                selectedAmenities={metaDetails.amenities} 
                onAmenitiesChange={(amenities) => setMetaDetails({ 
                  ...metaDetails, 
                  amenities 
                })} 
              />
            </div>
          </div>
          
          {/* Filter Actions */}
          <div className="flex items-center justify-between mt-[20px] sm:mt-[32px] px-[10px] sm:px-[15px] md:px-[10px] pb-[10px] sm:pb-[15px] md:pb-[10px] filter-actions-mobile">
            <BlackButton 
              text="Clear" 
              onClick={handleClear} 
            />
            <PurpleButton
              text={loading ? "Applying..." : "Apply Filters"}
              onClick={applyAllFilters}
              disabled={loading}
            />
          </div>
        </div>
      </FilterModal>
    </div>
  );
};

export default Filter;